export default (mountAutoComplete) =>
  mountAutoComplete({
    cocoonSelector: `[data-behaviour="users-not-in-group-list"]`,
    path: (element) =>
      Silverfin.Routes.unassigned_users_group_path(
        Silverfin.currentFirmId,
        element.dataset.groupId
      ),
    textfieldSelector: '[data-behaviour="user-autocomplete"]',
  })
